import { render, staticRenderFns } from "./new_food.vue?vue&type=template&id=1985d4f9"
import script from "./new_food.vue?vue&type=script&lang=js"
export * from "./new_food.vue?vue&type=script&lang=js"
import style0 from "./new_food.vue?vue&type=style&index=0&id=1985d4f9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports